import React, { Component } from "react";
import { Modal, Form, Row, Col, Input, Select, message } from "antd";
import { connect } from "react-redux";
import * as actionCreators from "./../../actions/requirement";
const { Option } = Select;

class FormRequirement extends Component {
    state = {
        loading: false,
    };
    checkResponse = (sucess) => {
        if (sucess) {
            message.success("Guardado com sucesso");
            this.props.hiddeModal();
            //TODO: remover posteriormente
            this.props.select({
                accao: "lista",
                lista: "requisitos",
                pagina: 1,
                resultados_pagina: 0,
                mostra_lista_eliminados: this.props.showDeletedRecords,
            });
            /****************************** */
        } else {
            message.error("Ocorreu um erro");
            this.setState({ loading: false });
        }
    };
    handleOk = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                if (this.props.isEdit) {
                    this.props
                        .update({
                            accao: "guardar",
                            formulario: "qa_requisitos.xml",
                            dados: JSON.stringify({
                                requisito: {
                                    ...values,
                                    id_requisito: this.props.dataToEdit.id_requisito,
                                    activo: true,
                                    versao:
                                        typeof this.props.dataToEdit.versao !== "object"
                                            ? this.props.dataToEdit.versao + 1
                                            : 1,
                                },
                            }),
                        })
                        .then((sucess) => {
                            this.checkResponse(sucess);
                        });
                } else {
                    this.props
                        .insert({
                            accao: "guardar",
                            formulario: "qa_requisitos.xml",
                            dados: JSON.stringify({
                                requisito: {
                                    ...values,
                                    activo: true,
                                    versao: 1,
                                },
                            }),
                        })
                        .then((sucess) => {
                            this.checkResponse(sucess);
                        });
                }
            }
        });
    };

    handleTipoChange = (value) => {
        this.props.form.setFieldsValue();
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const title = this.props.isEdit ? "Editar requisito" : "Nova requisito";
        return (
            <Modal
                title={title}
                visible={this.props.isVisible}
                onOk={this.handleOk}
                onCancel={this.props.hiddeModal}
                width="50%"
                confirmLoading={this.state.loading}
            >
                <Form layout="vertical">
                    <Row gutter={18}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Tipo de requisito">
                                {getFieldDecorator("tipo_requisito", {
                                    initialValue: this.props.dataToEdit.id_tipo_requisito,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        allowClear
                                        onChange={this.handleTipoChange}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.props.requirementTypeList.map((item) => (
                                            <Option key={item.id_tipo_requisito}>{item.designacao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Requisito">
                                {getFieldDecorator("designacao", {
                                    initialValue: this.props.dataToEdit.designacao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}
const mapDispatchToProps = {
    setField: actionCreators.setField,
    insert: actionCreators.insert,
    select: actionCreators.select,
    update: actionCreators.update,
};

const mapStateToProps = (state) => {
    return {
        formRequirement: state.requirement.domain.form,
        requirementTypeList: Object.values(state.requirementType.domain.byId),
    };
};

const formCreate = Form.create({
    mapPropsToFields(props) {
        if (!props.isEdit) {
            return {
                tipo_requisito: Form.createFormField({
                    ...props.formRequirement.tipo_requisito,
                    value: props.formRequirement.tipo_requisito.value,
                }),
                designacao: Form.createFormField({
                    ...props.formRequirement.designacao,
                    value: props.formRequirement.designacao.value,
                }),
            };
        }
    },
    onFieldsChange(props, fields) {
        if (!props.isEdit) props.setField(fields);
    },
})(FormRequirement);

export default connect(mapStateToProps, mapDispatchToProps)(formCreate);
